import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Получает контакты, с которыми можно вести чат по сущности ЖК.
 */
export function getNewbuildingChatContacts(builders, sellers) {
  var buildersWithChat = builders.filter(function (builder) {
    var _builder$chat;
    return ((_builder$chat = builder.chat) === null || _builder$chat === void 0 ? void 0 : _builder$chat.isEnabled) && builder.realtyUserId;
  });
  var sellersWithChat = sellers.filter(function (seller) {
    var _seller$chat;
    return ((_seller$chat = seller.chat) === null || _seller$chat === void 0 ? void 0 : _seller$chat.isEnabled) && seller.realtyUserId && !seller.isLeadFactory;
  });
  return [].concat(_toConsumableArray(buildersWithChat), _toConsumableArray(sellersWithChat));
}